__turbopack_context__.v({
  "active": "HVDuwq_active",
  "amountDue": "HVDuwq_amountDue",
  "backgroundTransition": "HVDuwq_backgroundTransition",
  "container": "HVDuwq_container",
  "dotMenu": "HVDuwq_dotMenu",
  "dueDate": "HVDuwq_dueDate",
  "installmentList": "HVDuwq_installmentList",
  "label": "HVDuwq_label",
  "listItemForCustomer": "HVDuwq_listItemForCustomer",
  "listItemForUserWithoutWidgets": "HVDuwq_listItemForUserWithoutWidgets",
  "listItemForVendor": "HVDuwq_listItemForVendor",
  "name": "HVDuwq_name",
  "paymentDate": "HVDuwq_paymentDate",
  "pulse-lightGray": "HVDuwq_pulse-lightGray",
  "selector": "HVDuwq_selector",
  "shake": "HVDuwq_shake",
  "shakeX": "HVDuwq_shakeX",
  "status": "HVDuwq_status",
  "value": "HVDuwq_value",
});
